import { Typescratcher as Ts } from "@tscratch3/typescratcher";

// 【画像読み込み】
import wallPng from '../../assets/wall.png';
export const WallImage = new Ts.Image( {
    wallPng 
} );
import cagePng from '../../assets/cage.png';
export const CageImage = new Ts.Image( { cagePng } );
import doorPng from '../../assets/door.png';
export const DoorImage = new Ts.Image( doorPng );

import SlimeSvg from '../../assets/slime_a.svg';
export const SlimeImage = new Ts.Image( SlimeSvg );
import BackdropBlackSvg from '../../assets/backdropBlack.svg';
export const BackdropBlackImage = new Ts.Image( BackdropBlackSvg );
import WaterSvg from '../../assets/water.svg';
export const WaterImage = new Ts.Image( WaterSvg );
